@if (justificationModalOpened) {
  <div tabindex="1">
    <div aria-labelledby="ngl_modal_header_1" aria-hidden="false" role="dialog" class="slds-modal slds-fade-in-open">
      <div class="slds-modal__container">
        <!-- Header -->
        <div class="slds-modal__header">
          <button type="button" nglbuttonicon="inverse" class="slds-modal__close slds-button slds-button--icon-inverse"
            (click)="close('CLOSE')">
            <i class="material-icons"
            style="font-size: 22px; top: -2px; left: -2px; margin: 0; cursor: pointer">&#xE5CD;</i>
          </button>
          <h2 id="ngl_modal_header_1" class="slds-text-heading--medium">{{modalTitle}}</h2>
          <button class="btn" (click)="close('SEND')">SEND</button>
        </div>
        <div class="slds-modal__content slds-p-around--medium" style="padding: 0 0 12px 0">
          <div class="form-group label-floating" [ngClass]="{ 'is-empty': currentEvent.eventUpdDesc === '' }"
            style="margin: 34px 10px 0 10px; height: calc(100% - 35px)">
            <label for="description" class="control-label">Justification</label>
            <textarea name="description" [(ngModel)]="currentEvent.eventUpdDesc"
            class="form-control textarea-modal"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="slds-backdrop slds-backdrop--open"></div>
  </div>
}
